// Whether wind is drawable at all, and whether it is showing.
//
// Wind is not one of the variables — it is a vector, and a colour ramp can only
// carry its length, so it rides on top of whichever scalar field is showing
// rather than competing for the same pixels. Its visibility is therefore its own
// state, independent of state.variable.
//
// `windOk` is a capability, not a preference: direction is a later addition to
// build-grids.ts, so a clone with older grids has no wd_sin/wd_cos and there are
// no arrows to draw. The toggle is then hidden rather than left switched on over
// an empty layer. Read once from the manifest in main().

import { state } from './state.ts';

let windOk = false;

export function setWindAvailable(ok: boolean): void {
  windOk = ok;
}

export function windAvailable(): boolean {
  return windOk;
}

export function windActive(): boolean {
  return windOk && state.windOn;
}
